import { render, staticRenderFns } from "./DepartmentCascade.vue?vue&type=template&id=4f0e8dc2&scoped=true&"
import script from "./DepartmentCascade.vue?vue&type=script&lang=js&"
export * from "./DepartmentCascade.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentCascade.vue?vue&type=style&index=0&id=4f0e8dc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0e8dc2",
  null
  
)

export default component.exports